import Mutations from '../../odata/mutations';

export default { ...new Mutations('contractItem'), ...new Mutations('contractItems') };
